import React from "react";
import Hero from "./Hero";
import TopFund from "./TopFund";
import MyNft from "./MyNft";
import Wagmi from "./Wagmi";
import HowUnique from "./HowUnique";
import { usePreview } from "../../../../context/PreviewContextProvider";


// Main Home component
const Home = () => {
  // Destructure various states from the outlet context
  const { data, previewCard, heroNfts, campaign } = usePreview();
  return (
    <div>
      <Hero data={data} heroNfts={heroNfts} campaign={campaign} previewCard={previewCard} />
      <TopFund data={data} previewCard={previewCard} />
      <MyNft data={data} />
      <HowUnique data={data} campaign={campaign} />
      <Wagmi data={data} campaign={campaign} />
    </div>
  );
};

export default Home;
